import { useEffect, useState } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { ApiError, type Me, api } from './api.js';
import { Detail } from './pages/Detail.js';
import { Inbox } from './pages/Inbox.js';

export function App() {
  const [me, setMe] = useState<Me | null>(null);
  const [denied, setDenied] = useState<string | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api
      .me()
      .then(setMe)
      .catch((error: unknown) => {
        // A 401 redirects to sign-in inside the client, so anything reaching
        // here is a signed-in person without access — which deserves a plain
        // explanation rather than an empty screen they will report as broken.
        if (error instanceof ApiError && error.status === 403) {
          setDenied(error.message);
        }
      })
      .finally(() => setReady(true));
  }, []);

  if (!ready) return <div className="empty">Loading…</div>;

  if (denied) {
    return (
      <div className="content">
        <div className="notice error" style={{ maxWidth: 620 }}>
          <strong>No access to the feedback dashboard.</strong>
          <p style={{ marginBlockEnd: 0 }}>{denied}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="shell">
      <header className="topbar">
        <Link to="/" className="brand" style={{ color: 'inherit' }}>
          Unified <span>Feedback</span>
        </Link>
        <div className="topbar-right">
          {me?.displayName && <span>{me.displayName}</span>}
          <a href="/auth/logout">Sign out</a>
        </div>
      </header>

      <main className="content">
        <Routes>
          <Route path="/" element={<Inbox />} />
          <Route path="/item/:ref" element={<Detail me={me} />} />
          <Route
            path="*"
            element={
              <div className="empty">
                That page does not exist. <Link to="/">Back to the inbox</Link>
              </div>
            }
          />
        </Routes>
      </main>
    </div>
  );
}
